import React, { useEffect, useState } from 'react';
import Header from '../../layouts/Header';
import {
    Table,
    Button,
    OverlayTrigger,
    Tooltip,
    Container,
    Modal,
    Row,
    Col,
    Form,
    Badge,
    Spinner
} from 'react-bootstrap';
import Select from 'react-select';
import { PlusCircleFill, PencilFill, TrashFill, EyeSlashFill, EyeFill, Download } from 'react-bootstrap-icons';
import { toast } from 'react-toastify';
import axiosInstance from '../../api/axios';import makeAnimated from "react-select/animated";
import { useSelector } from 'react-redux';

const ProductAddonAllocation = () => {
    const currentSkin = localStorage.getItem("skin-mode") ? "dark" : "";
    const [skin, setSkin] = useState(currentSkin);
    const accessToken = localStorage.getItem("authToken");
    const animatedComponents = makeAnimated();
    const { access } = useSelector((state) => state.login);
    const { loginEmail } = useSelector((state) => state.login);
    const email = loginEmail || localStorage.getItem("email");
    console.log("Email In Product Allocation :", email);
    
    const [menuAccess, setMenuAccess] = useState([]);

    console.log("Access :", access);

    useEffect(() => {
        if (Array.isArray(access)) {
            const filteredAccess = access?.filter((perm) =>
                perm?.startsWith("AddonAllocation:")
            );
            setMenuAccess(filteredAccess);
        }
    }, [access]);

    console.log("Menu Access:", menuAccess);

    const [allocations, setAllocations] = useState([]);
    const [productsList, setProductsList] = useState([]);
    const [addonsList, setAddonsList] = useState([]);
    const [outlets, setOutlets] = useState([]);
    const [showModal, setShowModal] = useState(false);
    // For expanding/collapsing a row
    const [expandedRow, setExpandedRow] = useState(null);
    const [isDeleteBtnLoading, setIsDeleteBtnLoading] = useState(false);
    const [downloadLoading, setDownloadLoading] = useState(false);

    // Filter states for product and addon group (title)
    const [filterProduct, setFilterProduct] = useState(null);
    const [filterAddon, setFilterAddon] = useState(null);
    const [showEditModal, setShowEditModal] = useState(false);
    const [addonData, setAddonData] = useState(null);
    const [isEditBtnLoading, setIsEditBtnLoading] = useState(false)
    const [selectedExcludedOption, setSelectedExcludedOption] = useState(null);
    const [formData, setFormData] = useState({
        product: null,
        addon: null,
        excludedValues: [],
        excludedOutlets: [],
        groupStatus: "INACTIVE",
        values: [
            {
                value: null,
                price: '',
                subLabel: '',
                excludedOutlets: [],
                status: "INACTIVE"
            }
        ]
    });

    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            width: "100%",
            borderRadius: "6px",
            minWidth: "200px",
            borderColor: state.isFocused ? "#80bdff" : "#ced4da",
            boxShadow: state.isFocused ? "0 0 0 0.2rem rgba(0,123,255,.25)" : null,
            "&:hover": {
                borderColor: state.isFocused ? "#80bdff" : "#ced4da"
            }
        }),
        placeholder: (provided) => ({
            ...provided,
            color: "#6c757d"
        })
    };

    // Map outlets to react-select options
    const outletData = outlets.map((outlet) => ({
        value: outlet._id,
        label: `${outlet.name} (${outlet.city})`
    }));

    const handleOpenAdd = async () => {
        setShowModal(true);
        setFormData({
            product: null,
            addon: null,
            excludedValues: [],
            groupStatus: "INACTIVE",
            values: [
                {
                    value: null,
                    price: '',
                    subLabel: '',
                    status: "INACTIVE"
                }
            ]
        })
    }

    // --- Data fetchers ---
    const getProductAddons = async () => {
        try {
            const headers = { Authorization: `Bearer ${accessToken}` };
            const response = await axiosInstance.get("addon-product-allocation", { headers });
            if (response?.data?.status) {
                const fetchedAllocations = response?.data?.data?.data || [];
                setAllocations(fetchedAllocations);
            }
        } catch (error) {
            toast.error("Failed to fetch addon product allocations", {
                position: "top-right",
                autoClose: 3000,
                theme: "colored"
            });
        }
    };

    const getProductsList = async () => {
        try {
            const headers = { Authorization: `Bearer ${accessToken}` };
            const response = await axiosInstance.get("product", { headers });
            if (response?.data?.status) {
                setProductsList(response?.data?.data?.products);
            }
        } catch (error) {
            toast.error("Failed to fetch products", {
                position: "top-right",
                autoClose: 3000,
                theme: "colored"
            });
        }
    };

    const getAddonsList = async () => {
        try {
            const headers = { Authorization: `Bearer ${accessToken}` };
            const response = await axiosInstance.get("addons?page=1&limit=50", { headers });
            if (response?.data?.status) {
                setAddonsList(response?.data?.data?.addons);
            }
        } catch (error) {
            toast.error("Failed to fetch addons", {
                position: "top-right",
                autoClose: 3000,
                theme: "colored"
            });
        }
    };

    // Fetch outlets
    const getOutlets = async () => {
        try {
            const headers = { Authorization: `Bearer ${accessToken}` };
            const response = await axiosInstance.get("outlet", { headers });
            if (response?.data?.status === true) {
                const filteredOutlets = response.data.data.outlets.filter(
                    (act) => act.status === "ACTIVE"
                );
                setOutlets(filteredOutlets);
            }
        } catch (error) {
            if (error?.response) {
                let errorMessage = "";
                if (error.response?.status === 406) {
                    errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error;
                } else if (error.response?.status === 412) {
                    errorMessage = error?.response?.data?.data?.message || error?.response?.data?.error;
                } else if (error.response?.status === 500) {
                    errorMessage = error?.response?.data?.error;
                }
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        }
    };

    // Download Addon Product Allocations
    const handleDownload = async () => {
        setDownloadLoading(true);
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };

            // Build URL with isDownload flag
            let url = `addon-product-allocation?isDownload=true`;

            const response = await axiosInstance.get(url, {
                headers,
                responseType: 'arraybuffer'
            });

            // Check content type
            const contentType = response.headers['content-type'] || '';

            // If response is JSON (error case), parse it
            if (contentType.includes('application/json')) {
                const decoder = new TextDecoder('utf-8');
                const text = decoder.decode(new Uint8Array(response.data));
                const errorData = JSON.parse(text);
                toast.error(errorData.error || errorData.message || "Failed to download allocations");
                setDownloadLoading(false);
                return;
            }

            // Generate standardized filename with timestamp
            const date = new Date();
            const timestamp = `${date.getFullYear()}${String(date.getMonth() + 1).padStart(2, '0')}${String(date.getDate()).padStart(2, '0')}_${String(date.getHours()).padStart(2, '0')}${String(date.getMinutes()).padStart(2, '0')}${String(date.getSeconds()).padStart(2, '0')}`;

            // Create filename
            let filename = `Addon_Product_Allocations_${timestamp}`;

            // Determine file extension based on content type
            if (contentType.includes('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')) {
                filename += '.xlsx';
            } else if (contentType.includes('application/vnd.ms-excel')) {
                filename += '.xls';
            } else if (contentType.includes('text/csv') || contentType.includes('application/csv')) {
                filename += '.csv';
            } else {
                filename += '.xlsx';
            }

            // Create blob with proper MIME type
            const blob = new Blob([response.data], {
                type: contentType || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });

            // Verify file is not empty
            if (blob.size === 0) {
                toast.error("Downloaded file is empty");
                setDownloadLoading(false);
                return;
            }

            // Create download link
            const downloadUrl = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();

            // Cleanup
            setTimeout(() => {
                document.body.removeChild(link);
                window.URL.revokeObjectURL(downloadUrl);
            }, 200);

            toast.success("Addon product allocations downloaded successfully!", {
                position: "top-right",
                autoClose: 3000,
                theme: "colored",
            });
        } catch (error) {
            console.error("Download error:", error);

            // Handle error responses
            if (error.response?.data instanceof ArrayBuffer || error.response?.data instanceof Uint8Array) {
                try {
                    const decoder = new TextDecoder('utf-8');
                    const text = decoder.decode(new Uint8Array(error.response.data));
                    const errorData = JSON.parse(text);
                    toast.error(errorData.error || errorData.message || "Failed to download allocations");
                } catch {
                    toast.error("Failed to download allocations. The server returned an unexpected response.");
                }
            } else if (error.response?.data?.error) {
                toast.error(error.response.data.error);
            } else {
                toast.error("Failed to download allocations. Please try again.");
            }
        } finally {
            setDownloadLoading(false);
        }
    };

    useEffect(() => {
        getProductAddons();
        getProductsList();
        getAddonsList();
        getOutlets();
    }, []);

    const handleDelete = async (allocationId) => {
        console.log("Delete allocation with id:", allocationId);
        toast.info(`Delete allocation ${allocationId}`);

        setIsDeleteBtnLoading(true);
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };

            // const data = {
            //     _id: menuGroupId,
            // };
            const response = await axiosInstance.delete(`addon-product-allocation?_id=${allocationId}`, { headers });
            if (response?.data?.status === true) {
                toast.success(response?.data?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
                getProductAddons();
                // set(false);
            }
        } catch (error) {
            console.log("Error  :", error);

            if (error.response.status === 403) {
                toast.error(error?.response?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            } else if (error.response.status === 404) {
                toast.error(error?.response?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }

            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        } finally {
            setIsDeleteBtnLoading(false);
        }
    };

    const handleToggleRow = (allocationId) => {
        setExpandedRow(expandedRow === allocationId ? null : allocationId);
    };

    // --- Form handlers (new allocation) ---
    const handleProductChange = (selectedOption) => {
        setFormData({ ...formData, product: selectedOption });
    };

    const handleAddonChange = (selectedOption) => {
        const selectedAddon = addonsList.find(addon => addon._id === selectedOption.value);
        const autoPopulatedValues = selectedAddon?.addonValues?.map(av => ({
            value: { value: av._id, label: `${av.sequenceNumber}. ${av.value}` },
            price: '',
            subLabel: '',
            status: av.status
        })) || [];
        setFormData({
            ...formData,
            addon: selectedOption,
            excludedValues: [],
            values: autoPopulatedValues
        });
        setAddonData(selectedAddon || null);
    };

    const handleValueChange = (index, field, value) => {
        const updatedValues = [...formData.values];
        updatedValues[index] = { ...updatedValues[index], [field]: value };
        setFormData({ ...formData, values: updatedValues });
    };

    const handleMainSelectChange = (selected, index, isGroup = false) => {
        if (isGroup) {
            setFormData((prev) => ({ ...prev, excludedOutlets: selected || [] }));
        } else {
            setFormData((prev) => {
                const updatedAddonValues = [...prev.values];
                updatedAddonValues[index] = {
                    ...updatedAddonValues[index],
                    excludedOutlets: selected || []
                };
                return { ...prev, values: updatedAddonValues };
            });
        }
    };

    const handleEditMainSelectChange = (selected, index, isGroup = false) => {
        if (isGroup) {
            setFormData((prev) => ({ ...prev, excludedOutlets: selected || [] }));
        } else {
            setFormData((prev) => {
                const updatedAddonValues = [...prev.values];
                updatedAddonValues[index] = {
                    ...updatedAddonValues[index],
                    excludedOutlets: selected || []
                };
                return { ...prev, values: updatedAddonValues };
            });
        }
    }

    const handleRemoveValue = (index) => {
        const removedRow = formData.values[index];
        const removedValue = removedRow?.value;

        if (!removedValue) return;

        const valueId = removedValue._id || removedValue.value;
        const label = removedValue.label || removedValue.value;

        if (!valueId) return;

        const updatedExcluded = [...formData.excludedValues];
        const alreadyExists = updatedExcluded.find(opt => opt.value === valueId);

        if (!alreadyExists) {
            updatedExcluded.push({
                value: valueId,
                label: label
            });
        }

        const updatedValues = formData.values.filter((_, idx) => idx !== index);

        setFormData({
            ...formData,
            values: updatedValues,
            excludedValues: updatedExcluded
        });
    };

    const handleRemoveExcludedValue = (removedOption) => {
        const updatedExcluded = formData.excludedValues.filter(
            (opt) => opt.value !== removedOption.value
        );
        const existsInAllocated = formData.values.find(
            (row) => row.value && row.value.value === removedOption.value
        );
        let updatedValues = formData.values;
        if (!existsInAllocated) {
            updatedValues = [
                ...formData.values,
                {
                    value: removedOption,
                    price: '',
                    subLabel: '',
                    status: "INACTIVE"
                }
            ];
        }
        setFormData({ ...formData, excludedValues: updatedExcluded, values: updatedValues });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const payload = {
            product: formData?.product?.value,
            addon: formData?.addon?.value,
            excludedOutlets: formData?.excludedOutlets?.map(ex => ex.value),
            excludedValues: formData?.excludedValues?.map(opt => opt.value),
            status: formData?.groupStatus,
            values: formData?.values?.map(val => ({
                value: val.value?.value,
                price: Number(val.price),
                subLabel: val.subLabel,
                status: val.status,
                excludedOutlets: val?.excludedOutlets?.map(ex => ex.value),
                isDefault: val.isDefault || false
            }))
        };
        try {
            const headers = { Authorization: `Bearer ${accessToken}` };
            const response = await axiosInstance.post("addon-product-allocation", payload, { headers });
            if (response?.data?.status) {
                toast.success("Product addon allocation created successfully!", {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored"
                });
                setFormData({
                    product: null,
                    addon: null,
                    excludedValues: [],
                    values: [{ value: null, price: '', subLabel: '', status: "INACTIVE" }]
                });
                setAddonData(null);
                setShowModal(false);
                getProductAddons();
            } else {
                toast.error("Failed to create allocation", {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored"
                });
            }
        } catch (error) {
            if (error?.response) {
                console.log("errorrr :", error);
                let errorMessage = "";
                if (error?.response?.status === 406) {
                    errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error;
                } else if (error.response?.status === 400) {
                    errorMessage = error?.response?.data?.data?.message || error?.response?.data?.error;
                } else if (error.response?.status === 409) {
                    errorMessage = error?.response?.data?.data?.message || error?.response?.data?.error;
                } else if (error.response?.status === 412) {
                    errorMessage = error?.response?.data?.data?.message || error?.response?.data?.error;
                } else if (error.response?.status === 500) {
                    errorMessage = error?.response?.data?.error;
                }
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        }
    };

    const openEditAllocationModal = (allocation) => {
        console.log("Alocation of Edit Modal :", allocation);
        console.log("Alocation of Edit Modal :", allocation?.status);

        const productOption = { value: allocation?.product?._id, label: allocation?.product?.name };
        const addonOption = { value: allocation?.addon?._id, label: allocation?.addon?.title };

        const mappedValues = allocation?.values?.map(val => ({
            _id: val?._id,
            value: {
                value: val?.value?.value,
                label: `${val?.value?.sequenceNumber || ''}. ${val?.value?.value}`,
                _id: val?.value?._id
            },
            price: val?.price,
            subLabel: val?.subLabel,
            excludedOutlets: val?.excludedOutlets?.map((out) => ({
                value: out._id,
                label: out.name
            })),
            isDefault: val?.isDefault || false
        }));

        const allocatedValueIds = allocation?.values?.map(val => val?.value?._id) || [];

        const allAddonValues = allocation?.addon?.addonValues || [];

        const unallocatedAddonValues = allAddonValues.filter(av => !allocatedValueIds.includes(av._id));

        const manualExcluded = (allocation?.excludedValues || []).map(ev => ({
            value: ev._id || ev.value,
            label: `${ev.sequenceNumber || ''}. ${ev.value || ev.label}`,
            _id: ev._id || ev.value
        }));

        const computedExcluded = unallocatedAddonValues.map(av => ({
            value: av._id,
            label: `${av.sequenceNumber}. ${av.value}`,
            _id: av._id
        }));

        const mergedExcluded = [...manualExcluded];

        computedExcluded.forEach((ce) => {
            if (!mergedExcluded.find(m => m.value === ce.value)) {
                mergedExcluded.push(ce);
            }
        });

        setFormData({
            _id: allocation?._id,
            product: productOption,
            addon: addonOption,
            groupStatus: allocation?.addon?.status,
            excludedValues: mergedExcluded,
            excludedOutlets: allocation?.excludedOutlets?.map((out) => ({
                value: out?._id,
                label: out?.name
            })),
            values: mappedValues
        });
        setAddonData(allocation?.addon);
        setShowEditModal(true);
    };

    const handleEditAllocationSubmit = async (e) => {
        e.preventDefault();
        setIsEditBtnLoading(true);
        const payload = {
            _id: formData?._id,
            product: formData.product?.value,
            addon: formData.addon?.value,
            excludedOutlets: formData.excludedOutlets.length > 0
                ? formData.excludedOutlets.map(opt => opt.value)
                : null,
            excludedValues: formData.excludedValues.map(opt => opt.value),
            status: formData.groupStatus,
            values: formData.values.map(val => ({
                _id: val?._id,
                value: val.value?._id,
                excludedOutlets: val?.excludedOutlets?.length > 0
                    ? val?.excludedOutlets?.map(opt => opt?.value)
                    : null,
                price: Number(val.price),
                subLabel: val.subLabel,
                status: val.status,
                isDefault: val.isDefault || false
            }))
        };
        try {
            const headers = { Authorization: `Bearer ${accessToken}` };
            const response = await axiosInstance.put(`addon-product-allocation`, payload, { headers });
            if (response?.data?.status) {
                toast.success("Addon allocation updated successfully!", {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored"
                });
                setShowEditModal(false);
                getProductAddons();
            } else {
                toast.error("Failed to update addon allocation", {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored"
                });
            }
        } catch (error) {
            toast.error("Error updating addon allocation", {
                position: "top-right",
                autoClose: 3000,
                theme: "colored"
            });
        } finally {
            setIsEditBtnLoading(false);
        }
    };

    // --- Filter Options ---
    const productOptions = productsList?.map(prod => ({
        value: prod._id,
        label: prod.name
    }));

    const addonOptions = addonsList?.map(addon => ({
        value: addon._id,
        label: addon.title
    }));

    // --- Filtering the allocations ---
    const filteredAllocations = allocations?.filter(allocation => {
        const matchProduct = filterProduct ? allocation?.product?._id === filterProduct?.value : true;
        const matchAddon = filterAddon ? allocation?.addon?._id === filterAddon?.value : true;
        return matchProduct && matchAddon;
    });

    // --- Group the filtered allocations by addon title ---
    const groupedAllocations = filteredAllocations?.reduce((acc, allocation) => {
        const key = allocation?.addon?.title;
        if (!acc[key]) {
            acc[key] = [];
        }
        acc[key].push(allocation);
        return acc;
    }, {});

    // --- For the form "Allocated Value" select ---
    const allocatedValueOptionsFull = addonData?.addonValues?.map(av => ({
        value: av?._id,
        label: `${av?.sequenceNumber}. ${av?.value}`
    })) || [];

    const getFilteredOptionsForRow = (currentRowValue) => {
        const selectedValues = formData.values
            .map(row => row.value?.value)
            .filter(val => val && val !== currentRowValue);
        return allocatedValueOptionsFull.filter(option =>
            !selectedValues.includes(option.value) || currentRowValue === option.value
        );
    };

    const anyDefault = formData.values.some(row => row.isDefault);

    return (
        <React.Fragment>
            <Header onSkin={setSkin} />
            <div className="main main-app p-3 p-lg-4">
                <div className="container shadow-sm" style={{ backgroundColor: "white" }}>
                    <Row>
                        <Col className="pt-4">
                            <h5 className="fw-semibold">ADDON MENU ALLOCATION</h5>
                        </Col>
                        <hr />
                    </Row>

                    {/* Filters */}
                    <Row className="mb-4 justify-content-between align-items-center">
                        <Col md={4}>
                            <Select
                                options={productOptions}
                                value={filterProduct}
                                onChange={setFilterProduct}
                                placeholder="Filter by Menu..."
                                isClearable
                            />
                        </Col>
                        <Col md={4}>
                            <Select
                                options={addonOptions}
                                value={filterAddon}
                                onChange={setFilterAddon}
                                placeholder="Filter by Addon Group..."
                                isClearable
                            />
                        </Col>
                        <Col md={4} className="text-end">
                            <div className="d-flex gap-2 justify-content-end">
                                {(menuAccess.includes("AddonAllocation:get") || email === "contact@xpansecafe.com") && (
                                    <Button
                                        variant="success"
                                        onClick={handleDownload}
                                        disabled={downloadLoading}
                                        className="d-flex align-items-center justify-content-center gap-1 w-50 fw-semibold"
                                    >
                                        {downloadLoading ? (
                                            <Spinner size="sm" animation="border" />
                                        ) : (
                                            <Download size={16} />
                                        )}
                                        {downloadLoading ? " Downloading..." : " Download"}
                                    </Button>
                                )}
                                {(menuAccess.includes("AddonAllocation:add") || email === "contact@xpansecafe.com") && (
                                    <Button variant="primary" onClick={handleOpenAdd}>
                                        <i className="ri-add-line" style={{ marginRight: "5px" }}></i> New Allocation
                                    </Button>
                                )}
                            </div>
                        </Col>
                    </Row>


                    <div>
                        {/* Grouped Table */}
                        {filteredAllocations?.length > 0 ? (
                            Object.keys(groupedAllocations)?.map(group => (
                                <div key={group} className="mb-5">
                                    {(menuAccess.includes("AddonAllocation:get") || email === "contact@xpansecafe.com") && (
                                        <>
                                            <h5 className="mb-3 fw-bold">
                                                {group}{" "}
                                                <Badge bg={groupedAllocations[group][0]?.addon?.status === "ACTIVE" ? "success" : "secondary"}>
                                                    {groupedAllocations[group][0]?.addon?.status}
                                                </Badge>
                                            </h5>
                                            <Table striped bordered hover responsive>
                                                <thead className="table-dark">
                                                    <tr>
                                                        <th>Menu</th>
                                                        <th>Category</th>
                                                        <th>Actions</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {groupedAllocations[group].map(allocation => (
                                                        <React.Fragment key={allocation._id}>
                                                            <tr>
                                                                <td className='fw-semibold'>{allocation?.product?.name}</td>
                                                                <td>{allocation?.product?.category?.name}</td>
                                                                <td className="text-center">
                                                                    {(menuAccess.includes("AddonAllocation:update") || email === "contact@xpansecafe.com") && (
                                                                        <OverlayTrigger placement="top" overlay={<Tooltip>Edit</Tooltip>}>
                                                                            <Button variant="outline-primary" size="sm" className="me-2" onClick={() => openEditAllocationModal(allocation)}>
                                                                                <PencilFill size={16} />
                                                                            </Button>
                                                                        </OverlayTrigger>
                                                                    )}
                                                                    {(menuAccess.includes("AddonAllocation:get") || email === "contact@xpansecafe.com") && (
                                                                        <OverlayTrigger
                                                                            placement="top"
                                                                            overlay={<Tooltip>{expandedRow === allocation?._id ? 'Hide Details' : 'View Details'}</Tooltip>}
                                                                        >
                                                                            <Button variant="link" size="sm" onClick={() => handleToggleRow(allocation._id)}>
                                                                                {expandedRow === allocation?._id ? (
                                                                                    <>
                                                                                        <EyeSlashFill size={16} className="me-1" />
                                                                                        Hide
                                                                                    </>
                                                                                ) : (
                                                                                    <>
                                                                                        <EyeFill size={16} className="me-1" />
                                                                                        View
                                                                                    </>
                                                                                )}
                                                                            </Button>
                                                                        </OverlayTrigger>
                                                                    )}
                                                                </td>
                                                            </tr>
                                                            {expandedRow === allocation._id && (
                                                                <tr>
                                                                    <td colSpan="3">
                                                                        <div style={{ padding: '1rem', backgroundColor: '#f7f7f7', borderRadius: '8px' }}>
                                                                            <h6 className="mb-3">
                                                                                {allocation.addon.title}{' '}
                                                                            </h6>
                                                                            {allocation?.addon?.addonValues && allocation?.addon?.addonValues.map(av => {
                                                                                const allocated = allocation?.values?.find(val => val?.value?._id === av._id);
                                                                                return (
                                                                                    <div key={av?._id} className="d-flex align-items-center mb-2 p-2 border rounded">
                                                                                        <div style={{ flex: '1' }}>
                                                                                            <strong>{av?.sequenceNumber}. {av?.value}</strong>{' '}
                                                                                            <Badge bg={av?.status === "ACTIVE" ? "success" : "secondary"}>
                                                                                                {av?.status}
                                                                                            </Badge>
                                                                                            {!allocated && (
                                                                                                <Badge bg="warning" text="dark" className="ms-2">
                                                                                                    Unallocated
                                                                                                </Badge>
                                                                                            )}
                                                                                        </div>
                                                                                        {allocated && (
                                                                                            <div className="text-end">
                                                                                                {allocated?.isDefault && (
                                                                                                    <Badge bg="info" className="ms-1">Default</Badge>
                                                                                                )}
                                                                                                <span className="me-2">Price: ₹{allocated.price}</span>
                                                                                                {allocated?.subLabel && <span className="me-2">({allocated?.subLabel})</span>}
                                                                                            </div>
                                                                                        )}
                                                                                    </div>
                                                                                );
                                                                            })}
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            )}
                                                        </React.Fragment>
                                                    ))}
                                                </tbody>
                                            </Table>
                                        </>
                                    )}
                                </div>
                            ))
                        ) : (
                            <p className="text-center text-muted">No addon menu allocations available.</p>
                        )}
                    </div>
                </div>
            </div>



            {/* New Allocation Modal */}
            <Modal show={showModal} onHide={() => setShowModal(false)} size="lg" centered>
                <Form onSubmit={handleSubmit}>
                    <Modal.Header closeButton style={{ backgroundColor: "#f8f9fa", borderBottom: "1px solid #e9ecef" }}>
                        <Modal.Title>Create Menu Addon Allocation</Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{ padding: "1.5rem" }}>
                        <Row className="mb-3">
                            <Col md={6}>
                                <Form.Group controlId="selectProduct">
                                    <Form.Label className='fw-semibold'>Menu <span className='text-danger'>*</span></Form.Label>
                                    <Select
                                        options={productOptions}
                                        value={formData.product}
                                        onChange={handleProductChange}
                                        placeholder="Select Menu..."
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group controlId="selectAddon">
                                    <Form.Label className='fw-semibold'>Addon <span className='text-danger'>*</span></Form.Label>
                                    <Select
                                        options={addonOptions}
                                        value={formData.addon}
                                        onChange={handleAddonChange}
                                        placeholder="Select addon..."
                                    />
                                </Form.Group>
                            </Col>
                            <Col md="6" className='mt-2'>
                                <Form.Group controlId="groupExcludedOutlets">
                                    <Form.Label className='fw-semibold'>Excluded Outlets For Main Addon</Form.Label>
                                    <Select
                                        isMulti
                                        options={outletData}
                                        value={formData.excludedOutlets}
                                        onChange={(selected) => handleMainSelectChange(selected, null, true)}
                                        components={animatedComponents}
                                        styles={customStyles}
                                        placeholder="Select outlets..."
                                    />
                                </Form.Group>
                            </Col>
                            {formData.excludedValues && formData.excludedValues.length > 0 && (
                                <Col md="6">
                                    <div className="mb-2 mt-2">
                                        <span className='fw-semibold'>Excluded Values:</span>
                                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem', marginTop: '0.5rem' }}>
                                            {formData.excludedValues.map((opt) => (
                                                <Badge
                                                    key={opt.value}
                                                    bg="secondary"
                                                    className="d-flex align-items-center"
                                                    style={{ cursor: 'pointer' }}
                                                    onClick={() => handleRemoveExcludedValue(opt)}
                                                >
                                                    {opt.label} <TrashFill size={12} className="ms-1" />
                                                </Badge>
                                            ))}
                                        </div>
                                    </div>
                                </Col>
                            )}
                        </Row>
                        {/* Additional form fields... */}
                        {formData.addon ? (
                            <>
                                <hr />
                                <h5 className="mb-3">Allocated Values</h5>
                                {formData.values.map((val, index) => (
                                    <Row key={index} className="mb-3 align-items-end">
                                        <Col md={4}>
                                            <Form.Group controlId={`allocatedValue-${index}`}>
                                                <Form.Label>Addon Value</Form.Label>
                                                <Select
                                                    options={getFilteredOptionsForRow(val.value ? val.value.value : null)}
                                                    value={val.value}
                                                    onChange={(selected) => handleValueChange(index, "value", selected)}
                                                    placeholder="Select addon value..."
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={3}>
                                            <Form.Group controlId={`allocatedPrice-${index}`}>
                                                <Form.Label>Price</Form.Label>
                                                <Form.Control
                                                    type="number"
                                                    step="any"
                                                    value={val.price}
                                                    onChange={(e) => handleValueChange(index, "price", e.target.value)}
                                                    placeholder="Price"
                                                    required
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={3}>
                                            <Form.Group controlId={`allocatedSubLabel-${index}`}>
                                                <Form.Label>Sub Label</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    value={val.subLabel}
                                                    onChange={(e) => handleValueChange(index, "subLabel", e.target.value)}
                                                    placeholder="Sub label"
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={2} className="text-center">
                                            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                                                {(!anyDefault || (anyDefault && val.isDefault)) && (
                                                    <Form.Group controlId={`allocatedDefault-${index}`}>
                                                        <Form.Check
                                                            type="switch"
                                                            id={`allocated-default-switch-${index}`}
                                                            label="Default"
                                                            checked={val.isDefault || false}
                                                            onChange={(e) => {
                                                                if (e.target.checked) {
                                                                    const updatedValues = formData.values.map((row, idx) => ({
                                                                        ...row,
                                                                        isDefault: idx === index
                                                                    }));
                                                                    setFormData({ ...formData, values: updatedValues });
                                                                } else {
                                                                    const updatedValues = formData.values.map((row, idx) =>
                                                                        idx === index ? { ...row, isDefault: false } : row
                                                                    );
                                                                    setFormData({ ...formData, values: updatedValues });
                                                                }
                                                            }}
                                                        />
                                                    </Form.Group>
                                                )}
                                                {formData.values.length > 1 && (
                                                    <Button variant="danger" size="sm" onClick={() => handleRemoveValue(index)}>
                                                        <TrashFill size={16} />
                                                    </Button>
                                                )}
                                            </div>
                                        </Col>
                                        <Col className='mt-2' md="12" lg="12">
                                            <Form.Group controlId={`excludedOutlets-${index}`}>
                                                <Form.Label>Excluded Outlets For Each Addon Value</Form.Label>
                                                <Select
                                                    isMulti
                                                    options={outletData}
                                                    value={val.excludedOutlets}
                                                    onChange={(selected) => handleMainSelectChange(selected, index)}
                                                    components={animatedComponents}
                                                    styles={customStyles}
                                                    placeholder="Select outlets..."
                                                />
                                            </Form.Group>
                                            <hr />
                                        </Col>
                                    </Row>
                                ))}
                            </>
                        ) : null}


                    </Modal.Body>
                    <Modal.Footer style={{ borderTop: "none", padding: "0.75rem 1.5rem" }}>
                        <Button variant="secondary" onClick={() => setShowModal(false)}>
                            Cancel
                        </Button>
                        <Button type="submit" variant="primary">
                            Submit Allocation
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>

            {/* Edit Allocation Modal */}
            <Modal show={showEditModal} onHide={() => setShowEditModal(false)} size="lg" centered>
                <Form onSubmit={handleEditAllocationSubmit}>
                    <Modal.Header closeButton style={{ backgroundColor: "#f8f9fa", borderBottom: "1px solid #e9ecef" }}>
                        <Modal.Title>Edit Menu Addon Allocation</Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{ padding: "1.5rem" }}>
                        <Row className="mb-3">
                            <Col md={6}>
                                <Form.Group controlId="editProduct">
                                    <Form.Label className='fw-semibold'>Menu</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={formData?.product ? formData?.product?.label : ""}
                                        readOnly
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group controlId="editAddon">
                                    <Form.Label className='fw-semibold'>Addon</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={formData?.addon ? formData?.addon?.label : ""}
                                        readOnly
                                    />
                                </Form.Group>
                            </Col>
                            {/* <Col md={3}>
                                <Form.Group controlId="editGroupStatus">
                                    <Form.Label>Status</Form.Label>
                                    <Form.Check
                                        type="switch"
                                        id="edit-group-status-switch"
                                        label={formData?.groupStatus === "ACTIVE" ? "Active" : "Inactive"}
                                        checked={formData?.groupStatus === "ACTIVE"}
                                        onChange={(e) =>
                                            setFormData(prev => ({
                                                ...prev,
                                                groupStatus: e.target.checked ? "ACTIVE" : "INACTIVE"
                                            }))
                                        }
                                        style={{ cursor: "pointer" }}
                                    />
                                </Form.Group>
                            </Col> */}
                        </Row>

                        <Row>
                            <Col md="6">
                                <Form.Group controlId="editGroupExcludedOutlets">
                                    <Form.Label className='fw-semibold'>Main Excluded Outlets</Form.Label>
                                    <Select
                                        isMulti
                                        options={outletData}
                                        value={formData.excludedOutlets}
                                        onChange={(selected) => handleEditMainSelectChange(selected, null, true)}
                                        components={animatedComponents}
                                        styles={customStyles}
                                        placeholder="Select outlets..."
                                    />
                                </Form.Group>
                            </Col>

                            <Col>
                                <Form.Group>
                                    <Form.Label className='fw-semibold'>Add Excluded Addon Value</Form.Label>
                                    <div className="d-flex gap-2">
                                        <Select
                                            options={formData.excludedValues}
                                            value={selectedExcludedOption}
                                            onChange={(selected) => setSelectedExcludedOption(selected)}
                                            placeholder="Select to add..."
                                            isClearable
                                            className='w-100'
                                        />
                                        <Button
                                            variant="success"
                                            onClick={() => {
                                                if (!selectedExcludedOption) return;

                                                // Remove from excluded
                                                const updatedExcluded = formData.excludedValues.filter(
                                                    (opt) => opt.value !== selectedExcludedOption.value
                                                );

                                                // Add to values
                                                const newValueRow = {
                                                    value: selectedExcludedOption,
                                                    price: '',
                                                    subLabel: '',
                                                    status: "INACTIVE",
                                                    isDefault: false,
                                                };

                                                const updatedValues = [...formData.values, newValueRow];

                                                setFormData({
                                                    ...formData,
                                                    excludedValues: updatedExcluded,
                                                    values: updatedValues,
                                                });

                                                setSelectedExcludedOption(null);
                                            }}
                                        >
                                            Add
                                        </Button>
                                    </div>
                                </Form.Group>
                            </Col>
                        </Row>

                        {formData?.excludedValues && formData?.excludedValues?.length > 0 && (
                            <Col>
                                <div className="mb-3">
                                    <span className='fw-semibold'>Excluded Values :</span>
                                    <div style={{ display: "flex", flexWrap: "wrap", gap: "0.5rem", marginTop: "0.5rem" }}>
                                        {formData?.excludedValues?.map((opt) => (
                                            <Badge
                                                key={opt?.value}
                                                bg="secondary"
                                                className="d-flex align-items-center"
                                                style={{ cursor: "pointer" }}
                                                onClick={() => handleRemoveExcludedValue(opt)}
                                            >
                                                {opt?.label} <TrashFill size={12} className="ms-1" />
                                            </Badge>
                                        ))}
                                    </div>
                                </div>
                            </Col>
                        )}



                        <hr />
                        <h5 className="mb-3">Allocated Values</h5>
                        {formData?.values?.map((val, index) => (
                            <>
                                <Row key={index} className="mb-2 align-items-end">
                                    <Col md={4}>
                                        <Form.Group controlId={`allocatedValue-edit-${index}`}>
                                            <Form.Label>Addon Value</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={val?.value ? val?.value?.label : ""}
                                                readOnly
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={2}>
                                        <Form.Group controlId={`allocatedPrice-edit-${index}`}>
                                            <Form.Label>Price</Form.Label>
                                            <Form.Control
                                                type="number"
                                                step="any"
                                                value={val?.price}
                                                onChange={(e) => handleValueChange(index, "price", e.target.value)}
                                                placeholder="Price"
                                                required
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={2}>
                                        <Form.Group controlId={`allocatedSubLabel-edit-${index}`}>
                                            <Form.Label>Sub Label</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={val?.subLabel}
                                                onChange={(e) => handleValueChange(index, "subLabel", e.target.value)}
                                                placeholder="Sub label"
                                            />
                                        </Form.Group>
                                    </Col>
                                    {/* <Col md={2}>
                                        <Form.Group controlId="editGroupStatus">
                                            <Form.Label>Status</Form.Label>
                                            <Form.Check
                                                type="switch"
                                                id="edit-group-status-switch"
                                                label={val?.status === "ACTIVE" ? "Active" : "Inactive"}
                                                checked={val?.status === "ACTIVE"}
                                                onChange={(e) => {
                                                    const updatedValues = formData?.values?.map((row, idx) => 
                                                        idx === index 
                                                            ? { ...row, status: e.target.checked ? "ACTIVE" : "INACTIVE" } 
                                                            : row
                                                    );
                                                    setFormData({ ...formData, values: updatedValues });
                                                }}
                                                style={{ cursor: "pointer" }}
                                            />
                                        </Form.Group>
                                    </Col> */}
                                    <Col md={2} className="text-center">
                                        <div style={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
                                            <Form.Group controlId={`allocatedDefault-edit-${index}`}>
                                                <Form.Check
                                                    type="switch"
                                                    id={`allocated-default-switch-edit-${index}`}
                                                    label="Default"
                                                    checked={val?.isDefault || false}
                                                    onChange={(e) => {
                                                        if (e.target.checked) {
                                                            const updatedValues = formData?.values?.map((row, idx) => ({
                                                                ...row,
                                                                isDefault: idx === index
                                                            }));
                                                            setFormData({ ...formData, values: updatedValues });
                                                        } else {
                                                            const updatedValues = formData?.values?.map((row, idx) =>
                                                                idx === index ? { ...row, isDefault: false } : row
                                                            );
                                                            setFormData({ ...formData, values: updatedValues });
                                                        }
                                                    }}
                                                />
                                            </Form.Group>
                                            {formData?.values?.length > 1 && (
                                                <Button variant="danger" size="sm" onClick={() => handleRemoveValue(index)}>
                                                    <TrashFill size={16} />
                                                </Button>
                                            )}
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md="12">
                                        <Form.Group controlId={`editExcludedOutlets-${index}`}>
                                            <Form.Label>Exclude Outlets</Form.Label>
                                            <Select
                                                isMulti
                                                options={outletData}
                                                value={val.excludedOutlets}
                                                onChange={(selected) => handleEditMainSelectChange(selected, index)}
                                                components={animatedComponents}
                                                styles={customStyles}
                                                placeholder="Select outlets..."
                                            />
                                        </Form.Group>
                                    </Col>
                                    <hr className='mt-2' />
                                </Row>
                            </>
                        ))}
                    </Modal.Body>
                    <Modal.Footer style={{ borderTop: "none", padding: "0.75rem 1.5rem" }}>
                        <Button variant="secondary" onClick={() => setShowEditModal(false)}>
                            Cancel
                        </Button>
                        <Button type="submit" variant="primary" disabled={isEditBtnLoading}>
                            {isEditBtnLoading ? <Spinner size='sm' /> : "Submit Allocation"}
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>

        </React.Fragment>
    );
};

export default ProductAddonAllocation;